import { columnsheadId } from '../../universal/columnshead';
import WebUniversalNewEx, { WUExtendPropsType } from '../../system/WebUniversalNewEx';
import ExpandCategoryEdit from './ExpandCategoryEdit';
import { useEffect, useRef } from 'react';
import { Switch } from 'antd';

export default function ExpandCategory(props: any) {

    const ref = useRef<any>(undefined);
    /** api服务id */
    const apiId = 'expandCategory';

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            // handleChangeOne = ref.current.handleChangeOne;
        }
        //同步获取数据 async - await
        const fetchData = async () => {
        }

        fetchData();
        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); //初始化数据


    //表头
    const columnsHead = [
        {
            title: '需求',
            dataIndex: 'menuWarehouseRequireMentName',
            render: (text: any, record: any) => {
                return (
                    <div>{record.menuWarehouseRequireMentName}</div>
                )
            }
        },
        {
            title: '需求类型',
            dataIndex: 'expandCategoryName',
        },
        {
            title: '关联',
            dataIndex: 'isRelation',
            render: (text: any, record: any) => (
                <Switch checkedChildren="是" unCheckedChildren="否"
                    checked={text} key={record.id}onChange={(e) => ref.current.handleChangeOne(record.id, 'isRelation', e, apiId)}
                />
            )
        },
        {
            title: '排序',
            dataIndex: 'sortBy',
        },
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '需求类型',
        apiId,
        showStates: true,
        columns,
        pagination: true,
        EditComponent: ExpandCategoryEdit,
        // mountDataOptions: {
        //     userMount: {
        //         isDept: true
        //     }
        // }
    };

    return (
        <>
            <WebUniversalNewEx props={extendProps} ref={ref}></WebUniversalNewEx>
        </>
    )
}